import { LiveUser } from 'shared/types/global'

import Flex from '../Flex'
import LiveAvatar from '../LiveAvatar'

type LiveAvatarsRowProps = {
  liveUsers: LiveUser[]
}

const LiveAvatarsRow: React.FC<LiveAvatarsRowProps> = ({
  liveUsers
}) => {
  return (
    <Flex>
      {liveUsers.map(liveUser => (
        <Flex key={liveUser.index}>
          <LiveAvatar liveUser={liveUser} enableTooltip />
        </Flex>
      ))}
    </Flex>
  )
}

export default LiveAvatarsRow
